import React from 'react';
import get from 'lodash/get';
import { useSelector } from 'react-redux';
import clsx from 'clsx';
import find from 'lodash/find';

import Link from 'app/components/misc/Link';
import { getCurrentCategory } from 'app/selectors/productSelector';
import slugify from 'slugify';
import { useRouter } from 'next/router';

const BankProviderList = () => {
  const router = useRouter();

  const currentCategory = useSelector(getCurrentCategory);
  const filters = get(currentCategory, 'filters', {});
  const filterItem = find(filters, { title: 'Bank Providers' });
  const options = filterItem?.options || [];

  return (
    <div className="card">
      <ul className="mt-8 first:mt-0">
        <h3 className="text-base font-bold">Card Providers</h3>
        {options.map(option => {
          const isSelected = router?.query?.bankProviders === option;
          const bankSlug = slugify(option, { lower: true });

          const link = `/reviews/credit-cards?bankProviders=${bankSlug}/`;
          const as = `/reviews/credit-cards/${bankSlug}/`;

          return (
            <li
              key={bankSlug}
              className={clsx(['mt-4', isSelected && 'text-blue-500'])}
            >
              <Link href={link} as={as}>
                <a data-testid="product-category-item">{option}</a>
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default BankProviderList;
